import { Query } from '@cubejs-client/core';
import PieGraphBase from '../PieGraphBase';

export default class PaymentMethodGraph extends PieGraphBase {
    headerKey = () => 'Payments.status'

    dataKey = () => 'Payments.count'

    graphName() { return 'Payment Method'; }

    query(): Query {
      return {
        order: {
          'FctPaymentMethod.count': 'desc',
        },
        measures: [
          'FctPaymentMethod.count',
        ],
        timeDimensions: [
          {
            dimension: 'FctPaymentMethod.dateDay',
            dateRange: 'This month',
          },
        ],
        dimensions: [
          'FctPaymentMethod.paymentMethod',
        ],
        filters: [
          {
            member: 'FctPaymentMethod.organisationId',
            operator: 'equals',
            values: [
              this.props.organisationId,
            ],
          },
          // {
          //   member: 'FctPaymentMethod.competitionId',
          //   operator: 'equals',
          //   values: [
          //     this.props.competitionId,
          //   ],
          // },
        ],
      };
    }
}
